import { entryItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const toneStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function QuickEntry() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-site mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <SectionHeading
            eyebrow="快捷入口"
            title="六个入口，直达你想做的动作"
            desc="不用在层级之间来回点。评论、话题、关注、私信、举报、下载，从首页一次点到，常用动作全部前置。"
          />
          <a
            href="#topics"
            className="self-start lg:self-auto h-10 px-5 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-900 inline-flex items-center gap-2 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部功能
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {entryItems.map((item, index) => (
            <a
              key={item.title}
              href={item.href}
              className={`animate-fade-up group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 hover:border-primary-300 transition-colors ${
                index % 3 === 1 ? "delay-100" : index % 3 === 2 ? "delay-200" : ""
              }`}
            >
              <span
                className={`w-10 h-10 rounded-md flex items-center justify-center ${
                  toneStyles[item.tone] ?? toneStyles.primary
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                {item.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700">
                {item.action}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}